@for (attachment of attachments(); track attachment.attachmentId) {
  <div>
    <app-link-info-file
      [file]="attachment.file"
      [withDraggable]="false"
      [withUnlink]="false"
      [withActions]="withActions"
      variant="attachment"
      (appClick)="clickStitchItem.emit(attachment.file)"
      (appDblClick)="dblClickStitchItem.emit(attachment.file)"
    />
  </div>
} @empty {
  @if (!loading()) {
    <app-no-content-stub imageSrc="assets/placeholders/placeholder-attachments.svg" [size]="76">
      <p class="text-base font-medium text-gray-900 text-center">No attachments</p>
    </app-no-content-stub>
  }
}
